/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Slotduration1Inputs */

const en__field_slotduration1 = /** @type {(inputs: _Field_Slotduration1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slot Duration`)
};

const de__field_slotduration1 = /** @type {(inputs: _Field_Slotduration1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dauer einer Einheit`)
};

/**
* | output |
* | --- |
* | "Slot Duration" |
*
* @param {_Field_Slotduration1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_slotduration1 = /** @type {((inputs?: _Field_Slotduration1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Slotduration1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_slotduration1(inputs)
	return de__field_slotduration1(inputs)
});
export { _field_slotduration1 as "_field_slotDuration" }